/**
 * App shell: the route (lobby or a room) plus the app-wide layers — toasts,
 * the screen-reader live regions, the connection banner, the "new version"
 * prompt and the help dialogs.
 */
import { useEffect } from 'react';
import { ConnectionBanner } from './components/ConnectionBanner';
import { HowToPlayDialog } from './components/HowToPlay';
import { LiveAnnouncer } from './components/LiveAnnouncer';
import { Lobby } from './components/Lobby';
import { RoomScreen } from './components/RoomScreen';
import { ShortcutsDialog } from './components/ShortcutsDialog';
import { Toasts } from './components/Toasts';
import { UpdatePrompt } from './components/UpdatePrompt';
import { leaveIfInRoom } from './net/session';
import { useRoute } from './router';
import './App.css';

export function App() {
  const route = useRoute();

  // Browser Back from a room to "/": leave the room like the Leave button
  // would (a disconnect mid-game — the seat stays resumable), even while
  // reconnecting.
  useEffect(() => {
    if (route.name === 'lobby') leaveIfInRoom();
  }, [route]);

  return (
    <div className="app">
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      {route.name === 'lobby' ? <Lobby /> : <RoomScreen key={route.code} code={route.code} />}
      <ConnectionBanner />
      <UpdatePrompt />
      <Toasts />
      <LiveAnnouncer />
      <HowToPlayDialog />
      <ShortcutsDialog />
    </div>
  );
}
